'use strict';

export class CommunicationMetadataCtrl
{
	ctrl = this;
	
	$scope;
	
	$mdDialog;
	
	jsDataService;
	
	message;
	
	data;
	
	constructor($scope, $mdDialog, jsDataService, message){
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.message = message;
		this.$scope = $scope;
		
		this.$scope.$parent.basicHttpConfigProcess({
			url: this.message.metadata_url,
			method: 'GET',
		})
		.then((response) => {
			this.data = response.data.data;
		});
	}
	
	close() {
		this.$mdDialog.cancel();
	}
}